import { classNames } from "@greeter/util";
import { addDays, set, subDays } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import css from "./DatePeriodInput.module.scss";
import { DateTimeInput } from "../DateTimeInput";
import { Log } from "@greeter/log";
import { ShallowDatePeriod } from "./types";
import { ValidateFn, validateFromIsBeforeTo } from "./validation";
import { ValidationResult } from "./validation";

export type DatePeriodInputProps = {
  id?: string;
  theme?: "light" | "dark";
  period: ShallowDatePeriod;
  onChange?: (value: ShallowDatePeriod) => void;
  onBlur?: React.ComponentProps<"input">["onBlur"];
  className?: string;

  validators?: Array<ValidateFn>;
};
export function DatePeriodInput(props: DatePeriodInputProps) {
  const theme = props.theme ?? "light";

  const [errors, setErrors] = useState<Array<ValidationResult>>([]);
  function validate() {
    Log.debug("[DatePeriodInput][validate] running validatiion");
    const errors = (
      [
        validateFromIsBeforeTo,
        ...(props.validators ?? []),
      ] satisfies Array<ValidateFn>
    )
      .map((v) => v(props.period))
      .filter((v) => !v.valid && v.reason);
    if (errors.length > 0) {
      setErrors(errors);
    } else {
      setErrors([]);
    }
  }

  useEffect(validate, [props.period]);

  return (
    <div
      id={props.id}
      {...classNames(
        css.DatePeriodInput,
        props.className,
        theme === "light" && css.Light,
        theme === "dark" && css.Dark
      )}
    >
      <DateTimeInput
        label="Fra"
        value={props.period.from}
        error={
          errors.filter(
            (e) =>
              ((e.level && e.level === "error") || !e.level) &&
              (e.target === "from" || e.target === "both")
          )[0]?.reason
        }
        warning={
          errors.filter(
            (e) =>
              ((e.level && e.level === "warn") || !e.level) &&
              (e.target === "from" || e.target === "both")
          )[0]?.reason
        }
        onBlur={validate}
        onValueChange={(v) => {
          if (!v) return;
          props.onChange?.({
            from: v,
            to: props.period.to,
          });
        }}
      />
      <DateTimeInput
        label="Til"
        value={props.period.to}
        error={
          errors.filter(
            (e) =>
              ((e.level && e.level === "error") || !e.level) &&
              (e.target === "to" || e.target === "both")
          )[0]?.reason
        }
        warning={
          errors.filter(
            (e) =>
              ((e.level && e.level === "warn") || !e.level) &&
              (e.target === "to" || e.target === "both")
          )[0]?.reason
        }
        onBlur={validate}
        onValueChange={(v) => {
          if (!v) return;
          props.onChange?.({
            from: props.period.from,
            to: v,
          });
        }}
      />
    </div>
  );
}
